module.exports = __webpack_public_path__ + "img/drug-4.c1d12ac0.png";